import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";
import { useState } from "react";

interface NameGateProps {
  propertyName?: string;
  submitting?: boolean;
  onSubmit: (name: string) => void;
}

/** Second gate on the public property chat: ask the visitor's name once. */
export function NameGate({ propertyName, submitting, onSubmit }: NameGateProps) {
  const [name, setName] = useState("");
  const trimmed = name.trim();

  return (
    <div className="bg-atmosphere grain flex h-dvh flex-col items-center justify-center gap-8 px-6">
      <div className="relative z-10 flex flex-col items-center gap-3 text-center">
        <Logo size={48} />
        {propertyName ? (
          <p className="font-display text-xl tracking-tight text-foreground">{propertyName}</p>
        ) : null}
        <p className="text-sm text-muted-foreground">
          대화를 시작하기 전에 이름을 알려주세요 · Please enter your name
        </p>
      </div>
      <form
        className="relative z-10 flex w-full max-w-xs flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          if (trimmed) onSubmit(trimmed);
        }}
      >
        <Input
          autoFocus
          value={name}
          maxLength={50}
          placeholder="이름 · Name"
          className="h-12 rounded-xl text-base"
          onChange={(e) => setName(e.target.value)}
        />
        <Button
          type="submit"
          className="h-12 rounded-xl text-base"
          disabled={!trimmed || submitting}
        >
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          대화 시작하기
        </Button>
      </form>
    </div>
  );
}
